import { render, staticRenderFns } from "./SchoolYear.vue?vue&type=template&id=7704c9cd&scoped=true"
import script from "./SchoolYear.vue?vue&type=script&lang=js"
export * from "./SchoolYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7704c9cd",
  null
  
)

export default component.exports